import { useFormikContext } from "formik";
import React from "react";
import { SourceEnum } from "../../../../enums/template";
import useUser from "../../../../hooks/useUser";
import { Template } from "../../../../models";
import TemplateContainer from "../common/TemplateContainer";
import ArticleType from "./ArticleType";
import AudienceSelector from "./AudienceSelector";
import EmbedVideoToggle from "./EmbedVideoToggle";
import IncludeExternalLinkToggle from "./IncludeExternalLinkToggle";
import IncludeFAQToggle from "./IncludeFAQToggle";
import IncludeImageToggle from "./IncludeImageToggle";
import MediaSetup from "./MediaSetup/MediaSetup";
import PointOfView from "./PointOfView";
import SourceSelector from "./SourceSelector";
import TemplateName from "./TemplateName";
import TitleType from "./TitleType";
import AdditionalContextInput from "../advancedSettings/AdditionalSettings/AdditionalContextInput";

const Setup = () => {
  const { user } = useUser();
  const { values } = useFormikContext<Partial<Template>>();

  const isTopItemsArticle = values.sourceId === SourceEnum.TOP_ITEMS;
  const isBestItemsArticle = values.sourceId === SourceEnum.BEST_ITEMS;

  return (
    <div className="animate-fadeIn space-y-6">
      <TemplateContainer>
        <TemplateName />
      </TemplateContainer>

      <TemplateContainer className="space-y-6">
        <SourceSelector />
        <MediaSetup />
      </TemplateContainer>

      <TemplateContainer className="space-y-6">
        {!isTopItemsArticle && !isBestItemsArticle && <IncludeImageToggle />}

        <IncludeExternalLinkToggle />

        {!isTopItemsArticle && !isBestItemsArticle && <EmbedVideoToggle />}

        {!isTopItemsArticle && <IncludeFAQToggle />}

        {!isTopItemsArticle && !isBestItemsArticle && <ArticleType />}

        {!isTopItemsArticle && !isBestItemsArticle && user?.isSuper && (
          <TitleType />
        )}

        <PointOfView />

        {(isTopItemsArticle || isBestItemsArticle) && <AudienceSelector />}

        {isBestItemsArticle && <AdditionalContextInput maxLength={2000} />}
      </TemplateContainer>
    </div>
  );
};

export default Setup;
